import { createAction, props } from '@ngrx/store';

export const setHideWelcomeScreen = createAction(
  '[Dashboard] Set Hide Welcome Screen',
  props<{ hideWelcomeScreen: boolean }>()
);
